export const SAMPLE_RESUME_DATA = {
  name: "Aarav Mehta",
  email: "aarav.mehta@example.com",
  phone: "+91 98765 43210",
  location: "Bengaluru, India",
  roleTitle: "Senior Product Designer",
  role: "Senior Product Designer",
  relevantExperience: "6",
  totalExperience: "8",
  summary:
    "Product designer focused on SaaS workflows, design systems, and conversion-focused user journeys across onboarding, billing, and analytics surfaces.",
  objective:
    "Create thoughtful, scalable digital products that turn complex workflows into clear and confident user experiences.",
  photo: "",
  linkedin: "linkedin.com/in/aaravmehta",
  github: "github.com/aaravmehta",
  experience: [
    {
      company: "Northstar Labs",
      role: "Senior Product Designer",
      project: "Growth and onboarding platform",
      projectDisplayMode: "",
      startDate: "Jan 2023",
      endDate: "Present",
      years: "2023 - Present",
      description:
        "<ul><li>Redesigned onboarding flows and improved trial-to-paid conversion by 24%.</li><li>Built a reusable design system used across product, marketing, and support surfaces.</li><li>Partnered with product and engineering on analytics dashboards for customer retention.</li></ul>",
    },
    {
      company: "Pixelcraft Studio",
      role: "Product Designer",
      project: "B2B workflow suite",
      projectDisplayMode: "",
      startDate: "Jun 2020",
      endDate: "Dec 2022",
      years: "2020 - 2022",
      description:
        "<ul><li>Led end-to-end design for collaboration, approvals, and reporting modules.</li><li>Created interactive prototypes to validate IA changes before development handoff.</li><li>Worked closely with engineers to ship accessible responsive experiences.</li></ul>",
    },
    {
      company: "Orbit Creative",
      role: "UX Designer",
      project: "E-commerce optimization",
      projectDisplayMode: "",
      startDate: "Jul 2018",
      endDate: "May 2020",
      years: "2018 - 2020",
      description:
        "<ul><li>Improved mobile checkout completion with clearer information hierarchy and trust cues.</li><li>Ran usability studies and translated findings into prioritized roadmap recommendations.</li></ul>",
    },
  ],
  skillGroups: {
    skills: [
      "Product Strategy",
      "Figma",
      "Design Systems",
      "UX Research",
      "Prototyping",
      "Analytics",
      "Wireframing",
      "Stakeholder Communication",
    ],
  },
  languages: ["English", "Hindi"],
  education: [
    {
      institution: "National Institute of Design",
      degree: "B.Des",
      field: "Communication Design",
      from: "2014",
      to: "2018",
      score: "8.8 CGPA",
    },
    {
      institution: "Google UX Certificate",
      degree: "Professional Certificate",
      field: "User Experience",
      from: "2019",
      to: "2019",
      score: "",
    },
  ],
  achievements:
    "<ul><li>Speaker at DesignUp on building measurable onboarding systems.</li><li>Mentored four junior designers into full-time product design roles.</li><li>Won internal innovation award for cross-functional dashboard redesign.</li></ul>",
};
